const applicationDetailModel = {
    id: null, // Guid?
  userId: null, // Guid

  eventName: null, // string?
  eventDescription: null, // string?
  eventStatusId: null, // int?
  eventCategoryTypeId: null, // Guid?
  countryId: null, // Guid?
  street1: null, // string?
  street2: null, // string?
  city: null, // string?
  stateId: null, // Guid?
  zip: null, // string?
  startDate: null, // DateOnly?
  startTime: null, // TimeOnly?
  endDate: null, // DateOnly?
  endTime: null, // TimeOnly?
  endTimeStr: null, // string?
  startTimeStr: null, // string?
  timeZoneId: null, // int?
  currencyId: null, // int?
  coverPicWide: null, // IFormFile?
  coverPicWideUrl: null, // string?
  coverPicSquare: null, // IFormFile?
  coverPicSquareUrl: null, // string?
  parkinginstructions: null, // string?
  healthSafetyInfo: null, // string?
  pitchAllocationType: null, // int?
  publishedDate: null, // DateTime?
  publishedStatus: null, // bool?
  startDateStr:null,
  endDateStr:null,
  eventStatusName: null, // string?
  eventCategoryTypeName: null, // string?
  countryName: null, // string?
  stateName: null, // string?
  currencyName: null, // string?
  subscriptionName: null, // string?
  timezoneName: null, // string?
  eventPitches: [], // string?
};
export default applicationDetailModel;